import { render, staticRenderFns } from "./order_info.vue?vue&type=template&id=80585f4e&scoped=true&"
import script from "./order_info.vue?vue&type=script&lang=js&"
export * from "./order_info.vue?vue&type=script&lang=js&"
import style0 from "./order_info.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./order_info.vue?vue&type=style&index=1&id=80585f4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80585f4e",
  null
  
)

export default component.exports